module.exports = __webpack_public_path__ + "static/freedom-two-minute-bf3301e7bb8f4c6b289ad63e3be11889.jpg";